import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
    AuthenticationService,
    EspaceClientService,
    PasswordService,
    User,
} from '@kv-common-components/kx-services';
import { PersonneHelperService } from '@shared/services/personne-helper.service';
import { NGXLogger } from 'ngx-logger';
import { Caisse } from './caisse-auto-complete/caisse';
import { crcaList } from './caisse-auto-complete/crca-list';
import { Subscription } from 'rxjs';
import { RouteEnum } from '@shared/services/route-enum';

@Component({
    selector: 'app-connexion',
    templateUrl: 'connexion.component.html'
})
export class ConnexionComponent implements OnInit, OnDestroy {
    defaultCaisse: Caisse;
    telControl = new FormControl();
    passwordControl = new FormControl();
    emailControl = new FormControl();
    loginForm: FormGroup;
    resetPwdQueryForm: FormGroup;
    isLoggedOut: boolean;
    resetPwdQuerySuccess: boolean;
    isLoading = false;
    isPwdUpdateVisible = false;
    resetPasswordLoading = false;

    loggedOutSubscription: Subscription;
    espaceClientSubscription: Subscription;

    constructor(
        private logger: NGXLogger,
        private authenticationService: AuthenticationService,
        private router: Router,
        private passwordService: PasswordService
    ) {}

    ngOnInit(): void {
        this.loginForm = new FormGroup({});
        this.resetPwdQueryForm = new FormGroup({});
        this.telControl.setValidators([
            Validators.required,
            Validators.pattern('^(?!00)[0-9]{10,15}$'),
        ]);
        this.loginForm.addControl('phone', this.telControl);
        this.passwordControl.setValidators([Validators.required]);
        this.loginForm.addControl('password', this.passwordControl);
        this.emailControl.setValidators([
            Validators.required,
            Validators.email,
        ]);
        this.resetPwdQueryForm.addControl('email', this.emailControl);
        this.defaultCaisse = this.getDefaultCaisse();
        if (this.defaultCaisse) {
            this.logger.debug('default caisse is :', this.defaultCaisse.name);
        } else {
            this.logger.debug('default caisse is not defined yet');
        }
        this.loggedOutSubscription =
            this.authenticationService.isLoggedOut.subscribe((isLoggedOut) => {
                this.isLoggedOut = isLoggedOut;
            });
    }

    ngOnDestroy() {
        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
        if (this.loggedOutSubscription) {
            this.loggedOutSubscription.unsubscribe();
        }
    }

    login(): void {
        this.isLoading = true;
        this.authenticationService
            .loginEADE(
                this.loginForm.value.phone,
                this.loginForm.value.password,
                this.defaultCaisse.id
            )
            .subscribe(
                (user: User) => {
                    this.logger.info('User: ', { user }, ' succesfully logged');
                    localStorage.setItem(
                        'currentPhone',
                        this.loginForm.value.phone
                    );
                    this.isLoading = false;
                    this.router.navigateByUrl(RouteEnum.otpConnexion);
                },
                (error) => {
                    this.isLoading = false;
                    /*
                     * we catch the error and throw it again so that
                     * the error-modal component can handle it
                     */
                    throw error;
                }
            );
    }

    getDefaultCaisse(): Caisse {
        const primaryProviderId = '20018'; // TODO remplacer par 20018 lors de l'assemblage
        if (!primaryProviderId) {
            return null;
        }

        const caisse: Caisse = crcaList.find(
            (crca) => crca.id === primaryProviderId
        );

        return caisse ? caisse : null;
    }

    // handleCaisseSelection(newCaisse: Caisse): void {
    //     this.defaultCaisse = newCaisse;
    // }

    openResetPassword(): void {
        this.resetPwdQuerySuccess = null;
        this.isPwdUpdateVisible = true;
    }

    goBackToLogin(): void {
        this.isPwdUpdateVisible = false;
    }

    validateResetQuery(): void {
        if (this.resetPwdQueryForm.valid && !this.resetPasswordLoading) {
            this.resetPasswordLoading = true;
            const email = this.resetPwdQueryForm.controls.email.value;
            const primaryProvider = '20018'; // TODO remplacer par 20018 lors de l'assemblage
            this.passwordService
                .resetPasswordQuery(email, primaryProvider)
                .subscribe(
                    (data) => {
                        this.resetPwdQuerySuccess = true;
                        this.resetPasswordLoading = false;
                    },
                    (error) => {
                        this.resetPwdQuerySuccess = false;
                        this.resetPasswordLoading = false;
                        throw error;
                    }
                );
        }
    }
}
